export default {
  'coupon.h1': 'Przewodnik po kuponach i kodach rabatowych USFans 2026',
  'coupon.lead': 'Dowiedz się, jak działają kupony i kody rabatowe USFans, gdzie szukać promocji i jak mieć pewność, że otrzymasz najlepszą wartość zamówienia.',
  'coupon.category': 'Kupony',
  'coupon.shortTitle': 'Przewodnik po kuponach USFans',
  'coupon.readTime': '6 min czytania',
  'coupon.toc': 'Spis treści',

  'coupon.s1.title': 'Jak działają kupony',
  'coupon.s1.p1': 'Kupon lub kod rabatowy to krótki kod, który wpisujesz przy kasie, aby obniżyć cenę zamówienia. Kupony mogą mieć różne formy — procent zniżki, stała kwota lub darmowa wysyłka przy kwalifikujących się zamówieniach.',
  'coupon.s1.p2': 'W większości sklepów internetowych, w tym USFans, kod jest stosowany podczas kasy przed zakończeniem płatności, dzięki czemu możesz zobaczyć skorygowaną sumę przed potwierdzeniem zamówienia.',

  'coupon.s2.title': 'Gdzie szukać promocji',
  'coupon.s2.p1': 'Promocje są często ogłaszane na stronie sklepu, w newsletterze lub podczas sezonowych wyprzedaży. Sprawdzanie sklepu w okresach zakupowych lub świątecznych to dobry moment na znalezienie aktywnych ofert.',
  'coupon.s2.p2': 'Ponieważ oferty często się zmieniają i są ograniczone czasowo, kod, który działał wczoraj, może już nie być ważny. Zawsze sprawdzaj bieżące szczegóły promocji bezpośrednio w sklepie.',

  'coupon.s3.title': 'Rodzaje rabatów',
  'coupon.s3.p1': 'Rabaty procentowe obniżają sumę o określony procent, a rabaty kwotowe odejmują stałą wartość od zamówienia. Niektóre kody oferują darmową wysyłkę, a inne mogą dotyczyć tylko konkretnych kategorii lub wymagać minimalnej kwoty zamówienia.',
  'coupon.s3.p2': 'Ważne jest czytanie warunków każdej oferty, ponieważ kod, który wygląda hojnie, może mieć warunki — takie jak minimalna kwota zakupu lub wykluczenia niektórych produktów.',

  'coupon.s4.title': 'Jak uzyskać najlepszą wartość',
  'coupon.s4.p1': 'Aby uzyskać najlepszą wartość, porównaj kilka rzeczy: samą zniżkę, ewentualny minimalny wydatek i to, czy interesujący Cię produkt jest objęty ofertą. Czasem mniejsza zniżka bez minimum jest lepsza niż większa z surowymi warunkami.',
  'coupon.s4.p2': 'Warto też sprawdzić, czy rabat łączy się z wysyłką lub innymi ofertami. W wielu przypadkach na jedno zamówienie można użyć tylko jednego kodu, więc wybierz ten, który daje największą oszczędność.',

  'coupon.s5.title': 'Porównanie rodzajów rabatów',
  'coupon.s5.p1': 'Poniższa tabela porównuje typowe rodzaje kuponów, aby pomóc Ci zrozumieć, który pasuje do Twojego zamówienia.',
  'coupon.table.c1': 'Rodzaj',
  'coupon.table.c2': 'Jak działa',
  'coupon.table.c3': 'Warto wiedzieć',
  'coupon.table.c4': 'Najlepszy dla',
  'coupon.table.r1c1': 'Procent zniżki',
  'coupon.table.r1c2': 'Obniża sumę o %',
  'coupon.table.r1c3': 'Oszczędność rośnie z zamówieniem',
  'coupon.table.r1c4': 'Większych zamówień',
  'coupon.table.r2c1': 'Stała kwota',
  'coupon.table.r2c2': 'Odejmuje ustaloną wartość',
  'coupon.table.r2c3': 'Może wymagać minimum',
  'coupon.table.r2c4': 'Mniejszych zamówień',
  'coupon.table.r3c1': 'Darmowa wysyłka',
  'coupon.table.r3c2': 'Usuwa opłatę za wysyłkę',
  'coupon.table.r3c3': 'Zwykle dla kwalifikujących się',
  'coupon.table.r3c4': 'Oszczędności na dostawie',
  'coupon.table.r4c1': 'Oferta kategorii',
  'coupon.table.r4c2': 'Dotyczy konkretnych produktów',
  'coupon.table.r4c3': 'Sprawdź, które się kwalifikują',
  'coupon.table.r4c4': 'Ukierunkowanych zakupów',

  'coupon.s6.title': 'Unikanie wygasłych kodów',
  'coupon.s6.p1': 'Wygasłe lub nieprawidłowe kody są powszechne. Gdy kod nie działa, zwykle oznacza to, że oferta się zakończyła, kod został źle wpisany lub zamówienie nie spełnia warunków.',
  'coupon.s6.p2': 'Najbardziej niezawodnym sposobem na znalezienie ważnego kodu jest sprawdzenie bezpośrednio oficjalnego sklepu, ponieważ to tam aktualne promocje są wymieniane dokładnie.',

  'coupon.s7.title': 'Bezpieczne korzystanie z ofert',
  'coupon.s7.p1': 'Uważaj na strony zewnętrzne obiecujące niezwykle duże zniżki, ponieważ czasem mogą prowadzić do wygasłych lub mylących ofert. Najbezpieczniejszym źródłem rabatu jest strona sklepu lub oficjalna komunikacja.',
  'coupon.s7.p2': 'Nigdy nie udostępniaj danych płatności ani konta żadnej stronie w zamian za kod i zawsze dokończ zakup na oficjalnej stronie kasy.',

  'coupon.conclusion.title': 'Podsumowanie',
  'coupon.conclusion.p1': 'Kupony i kody rabatowe USFans mogą obniżyć sumę zamówienia, ale ich wartość zależy od warunków i tego, czy dotyczą Twojego zamówienia. Sprawdzenie oficjalnego sklepu to najlepszy sposób na znalezienie aktywnych, ważnych ofert.',
  'coupon.conclusion.p2': 'Chcesz zrobić zakupy? Przejrzyj kategorie na stronie głównej lub przejdź bezpośrednio do pełnego sklepu.',

  'coupon.cta': 'Zobacz oferty USFans',
  'coupon.backHome': 'Wróć na stronę główną',
};